<script>
    import { ref } from "vue";
    const url = new URL(window.location);
    export default {
        props: {
            hasUrlparams: {
                type: Boolean,
                default: false
            },
            tabsClasses: {
                type: String,
                default: ''
            },
            tabsWrapperClasses: {
                type: String,
                default: ''
            },
            tabsColor: {
                type: String,
                default: ''
            },
            dropdownLabel: {
                type: String,
                default: 'Meer'
            },
            navigateLabel: {
                type: String,
                default: 'Navigeer'
            },
            activeBold: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                selectedIndex: 0,
                allTabs: [],
                tabArray: [],
                tabElements: [],
                tabWidths: [],
                dropdownArray: [],
                uniqueId: 'uid',
                dropdownOpen: false,
                firstLoad: true
            }
        },
        watch: {
            selectedIndex(val) {
                if (this.hasUrlparams) {
                    if (val !== 0) {
                        if (val >= this.tabArray.length) {
                            url.searchParams.set('tab-' + this.uniqueId, this.dropdownArray[val - this.tabArray.length].title.replaceAll(' ', '-'));
                        } else {
                            url.searchParams.set('tab-' + this.uniqueId, this.tabArray[val].title.replaceAll(' ', '-'));
                        }
                    } else {
                        url.searchParams.delete('tab-' + this.uniqueId);
                    }
                    window.history.pushState({}, '', url);
                }
            }
        },
        methods: {
            selectTab(i) {
                this.selectedIndex = i
                this.tabArray.forEach((tab, index) => {
                    tab.isActive = (index === i)
                });
                this.dropdownArray.forEach((tab, index) => {
                    tab.isActive = (index === i - this.tabArray.length)
                });
            },
            resolveActiveTab() {
                let queryString = window.location.search;
                let urlParams = new URLSearchParams(queryString);
                if (urlParams.has('tab-' + this.uniqueId)) {
                    this.selectedIndex = this.tabArray.findIndex(t => t.title === urlParams.get('tab-' + this.uniqueId).replaceAll('-', ' '));
                    if (this.selectedIndex === -1) {
                        this.selectedIndex = this.dropdownArray.findIndex(t => t.title === urlParams.get('tab-' + this.uniqueId).replaceAll('-', ' ')) + this.tabArray.length;
                    }
                    if (this.selectedIndex === -1) this.selectedIndex = 0;
                }
            },
            resize() {
                let maxWidth = this.$el.nextElementSibling.getBoundingClientRect().width;
                let itemsWidth = 0;
                let found = false;
                this.tabArray = [...this.allTabs];
                this.dropdownArray = [];
                this.tabWidths.forEach((width, index) => {
                    itemsWidth += width;
                    if (itemsWidth > maxWidth) {
                        if (!found) {
                            found = true;
                            this.tabArray = this.allTabs.slice(0, index);
                            this.dropdownArray = this.allTabs.slice(index, this.allTabs.length);
                        }
                    }
                });
            },
            handleClickOutside(event) {
                const targetElement = this.$refs.tabmore;
                if (targetElement) {
                    if (!targetElement.contains(event.target)) {
                        this.dropdownOpen = false;
                    }
                }
            }
        },
        created() {
            this.uniqueId += this.$.uid;
        },
        updated() {
            if (this.firstLoad) {
                this.$nextTick(() => {
                    this.tabElements = [...this.$refs.tabs];
                    this.tabElements.forEach(tab => {
                        this.tabWidths.push(tab.getBoundingClientRect().width);
                    });
                    this.resize();
                    window.addEventListener('resize', this.resize);
                });
                this.resolveActiveTab();
                if (this.selectedIndex > this.tabArray.length) {
                    this.dropdownArray[this.selectedIndex - this.tabArray.length].isActive = true;
                } else {
                    this.tabArray[this.selectedIndex].isActive = true;
                }
                this.firstLoad = false;
            }
        },
        mounted() {
            this.tabArray = [...this.allTabs];
        }
    }
</script>

<template>
    <div :class="tabsWrapperClasses">
        <div :class="['tabs','tabs-vue', tabsClasses, tabsColor]">
            <ul>
                <li :class="['is-relative', index === selectedIndex ? 'is-active' : '']" v-for="(tab, index) in tabArray" :key="tab.title" @click="selectTab(index)" ref="tabs">
                    <a :class="[index === selectedIndex && activeBold ? 'has-text-weight-bold' : '']">{{ tab.title }}</a>
                </li>
                <li :class="['tabs-dropdown', selectedIndex >= tabArray.length ? 'is-active' : '']" v-if="dropdownArray.length" ref="tabmore">
                    <div :class="['dropdown', 'is-right', dropdownOpen ? 'is-active' : '']">
                        <div class="dropdown-trigger">
                            <a aria-haspopup="true" :aria-controls="uniqueId" @click="dropdownOpen = !dropdownOpen">
                                <span :class="[selectedIndex >= tabArray.length && activeBold ? 'has-text-weight-bold' : '']" v-if="tabArray.length">{{dropdownLabel}}</span>
                                <span :class="[selectedIndex >= tabArray.length && activeBold ? 'has-text-weight-bold' : '']" v-else>{{navigateLabel}}</span>
                                <span class="icon is-small">
                                    <i class="fa-solid fa-angle-down fa-xs" aria-hidden="true"></i>
                                </span>
                            </a>
                        </div>
                        <div class="dropdown-menu" :id="uniqueId" role="menu">
                            <div class="dropdown-content">
                                <span :class="['is-clickable', 'dropdown-item', index === selectedIndex - tabArray.length ? 'is-active has-text-weight-bold' : '']" v-for="(item, index) in dropdownArray" @click="selectTab(index + tabArray.length); dropdownOpen = false">
                                    {{item.title}}
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <slot></slot>
</template>
